import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
// Fix for default marker icon in react-leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});
export function Location() {
  const {
    t
  } = useLanguage();
  const position: [number, number] = [34.0622, -118.3634]; // Wilshire Blvd, Beverly Hills area
  return <section className="py-20 lg:py-28 bg-white" data-id="element-226">
      <div className="container mx-auto px-6" data-id="element-227">
        <div className="grid lg:grid-cols-12 gap-16 lg:gap-24 items-center max-w-6xl mx-auto" data-id="element-228">
          <div className="lg:col-span-4" data-id="element-229">
            <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-230">
              {t('location.eyebrow')}
            </span>
            <h2 className="text-4xl md:text-5xl font-serif font-light text-brand-dark mb-12 tracking-tight" data-id="element-231">
              {t('location.heading')}
            </h2>

            <div className="space-y-10" data-id="element-232">
              <div data-id="element-233">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-234">
                  {t('location.addressLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80 leading-relaxed" data-id="element-235">
                  6404 Wilshire Blvd
                  <br data-id="element-236" />
                  Suite 610
                  <br data-id="element-237" />
                  Los Angeles, CA 90048
                </p>
              </div>

              <div data-id="element-238">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-239">
                  {t('location.phoneLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80" data-id="element-240">
                  <a href="tel:+17026604534" className="hover:text-brand-dark transition-colors" data-id="element-241">
                    (702) 660-4534
                  </a>
                </p>
              </div>

              <div data-id="element-242">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-243">
                  {t('location.hoursLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80 leading-relaxed" data-id="element-244">
                  {t('location.hours')}
                </p>
              </div>

              <div className="pt-4" data-id="element-245">
                <button onClick={() => document.getElementById('contacto')?.scrollIntoView({
                behavior: 'smooth'
              })} className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/70 hover:text-brand-dark transition-colors inline-flex items-center gap-2 border-b border-brand-gold/40 pb-1" data-id="element-246">
                  {t('nav.cta')} →
                </button>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 h-[500px] lg:h-[600px] w-full rounded-[2rem] overflow-hidden border border-brand-stone/50 z-0" data-id="element-247">
            <MapContainer center={position} zoom={13} scrollWheelZoom={false} className="w-full h-full" data-id="element-248">
              <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png" data-id="element-249" />
              <Marker position={position} data-id="element-250">
                <Popup data-id="element-251">
                  Lipo Laser · Beverly Hills <br data-id="element-252" /> {t('location.address')}
                </Popup>
              </Marker>
            </MapContainer>
          </div>
        </div>
      </div>
    </section>;
}